import React, {Fragment, useEffect,  useState} from 'react';
import PropTypes from "prop-types";
import moment from "moment";

import {useForm} from "react-hook-form";
import ModalContentWrapper from '../ModalContentWrapper';
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Components/SpinnerDiv";
import {getPostDetails, updatePost} from "root/DataFunctions/PostDataFns";
import {getChildForUser, getChildImageUrl} from "root/DataFunctions/ChildDataFns";
import {IconPath, MessageStatus, MessageType, QueueType, UserTypes} from "root/DataFunctions/Constants";
import DatePickerControl from "root/ReactHookForm/ControlWrappers/DatePickerControl";
import {PostStatus} from "root/DataFunctions/Constants";
import {getMessageReplyThread} from "root/DataFunctions/MessageDataFns";
import phpVars from 'phpVars';

const ModalApprovePost = (props) =>
{
    const [data, setData] = useState({ isLoading: props.post_id !== null, data: [] });
    const [ messageReplyThread, setMessageReplyThread ] = useState ('') ;
    const [isRecipientEditor, setIsRecipientEditor] = useState(false );

    const logged_in_user = phpVars.user_id;

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                post: {
                    child_uid: null,
                    from: '',
                    to: '',
                    title: '',
                    text: '',
                    link: '',
                    event_date: null,
                    document: '',
                    attach_image: 0,
                    comment: '',
                    letterbox_routing_required: false,
                    letterbox_comment: '',
                    reply_to_post_id: 0,
                    status: 0
                }
            }
        });

    useEffect(() =>
    {
        if ( props.post_id !== null )
        {
            getPostDetails(props.post_id, (response) =>
            {
                let postData = getDataFromResponse(response)[0] ;
                let event_date_object = moment(postData.event_date).toDate();

                //Message Reply Thread
                let replyToPostId = "";
                let replySubject = "";

                //Check if this is the first reply or part of a thread
                if (postData.reply_to_post_id) {
                    replyToPostId = postData.reply_to_post_id;
                    replySubject = postData.title;
                } else {
                    replyToPostId = postData.post_id;
                    replySubject = "Re: " + postData.title;
                }

                // This checks if the message is a reply
                if(postData.reply_to_post_id) {
                    setValue ( 'post',
                        { child_uid: {value: postData.unenc_recipient_user_id},
                            to: postData.known_as,
                            from: postData.posted_by_name,
                            title : replySubject,
                            text : postData.text,
                            comment: postData.approval_comment,
                            document: postData.document_array[0],
                            reply_to_post_id: replyToPostId,
                            status: postData.status
                        }) ;
                }
                else
                {
                    setValue('post',
                        {
                            from: postData.posted_by_name,
                            to: postData.known_as,
                            title: postData.title,
                            text: postData.text,
                            link: postData.link,
                            event_date: event_date_object,
                            document: postData.post_doc_id,
                            child_uid: postData.recipient_user_id,
                            comment: postData.approval_comment,
                            letterbox_routing_required: postData.letterbox_routing_required,
                            letterbox_comment: postData.letterbox_comment,
                            reply_to_post_id: replyToPostId,
                            status: postData.status
                        });
                }

                setData({ isLoading: false, data: postData });

                getMessageReplyThread(postData.date_created, replyToPostId, (response) =>
                {
                    const messageTrailData = getDataFromResponse(response);
                    setMessageReplyThread(messageTrailData);
                });

                getChildForUser( postData.recipient_user_id, logged_in_user,(response) =>
                {
                    const toChildData = getDataFromResponse(response);
                    const isChildEditor = toChildData.length > 0 ? toChildData[0]['is_editor'] : false;
                    setIsRecipientEditor(isChildEditor);
                });


            });
        }
    }, []);

    const onSubmit = ( data, status ) =>
    {
        data.post['operation'] = 'update_status';
        data.post['status'] = status;

        updatePost(data.post['child_uid'], props.post_id, data, props.messageType, (response) =>
        {
            props.onSaveCompleted ('saved');
            props.onClose() ;
        });
    }

    const onClickCancel = () =>
    {
        props.onSaveCompleted ('cancel');
        props.onClose() ;
    }

    const onClickAction = (status) => {
        handleSubmit(onSubmit)(status);
    }

    const getDocumentUrl = (  ) =>
    {
        let url = '/getFile.php?enc_docid=' + data.data.document_array[0];
        return url;
    }

    const getDocumentIcon = (  ) =>
    {
        let icon = IconPath.ICON_DOCUMENT;
        return icon;
    }

    const buildTitle = (mode, messageType) =>{
        const message_type = +messageType === MessageType.MESSAGE_TYPE_LIFESTORY ? ' Post' : ' Message';
        return mode +  message_type;
    } ;


    const Title = (props) =>
    {
        return <h3>{buildTitle(props.mode, props.messageType)}</h3>
    }

    const getReturnButtonText = () => {
        const returnButtonText = data.data.letterbox_routing_required && data.data.userTypeId !== UserTypes.CHILD ? 'Return to Letterbox' : 'Return to Sender';
        return returnButtonText;
    }

    const getSubmitButtonText = () => {
        const recipientIsChild = +data.data.recipient_user_type_id === UserTypes.CHILD ? true : false;
        const returnButtonText = +data.data.queue_id === QueueType.QUEUE_TO_APPROVE_OUTGOING && !isRecipientEditor && recipientIsChild ? 'Forward' : 'Approve';
        return returnButtonText;
    }

    const renderHookForm = ( prop )  =>
    {
        const isReadOnly = props.mode !== 'Action' && props.mode !== 'Hold Back';
        const readOnlyMode = props.mode === 'Action' && props.mode !== 'Hold Back' ? false : true ;
        //It needs outgoing approval if the queue is outgoing and the ogged in user is not the editor - else we show approval functionality (not forward)
        const outGoingApproval = +data.data.queue_id  === QueueType.QUEUE_TO_APPROVE_OUTGOING && !isRecipientEditor ? true :false;
        const hasLetterboxComment = data.data.letterbox_comment !== null && data.data.letterbox_comment !== '';
        const isApproved = +data.data.status === MessageStatus.APPROVED;
        const isHeld = +data.data.status === MessageStatus.PENDING;
        const isArchived = +data.data.status === MessageStatus.ARCHIVED;


        return (
            <Fragment>

                <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>
                    <div className='row'>
                        <div className='col-md-6'>
                            <label>From</label>
                            <input className='form-control' name='post.from' id='from' {...register("post.from")} readOnly={true}/>
                        </div>

                        <div className='col-md-6'>
                            <label>To</label>
                            <input className='form-control' name='post.to' id='to' {...register("post.to")} readOnly={true}/>
                        </div>
                    </div>

                    <label>Title</label>
                    <input className='form-control' name='post.title' id='title' {...register("post.title")} readOnly={true}/>

                    <label>Text</label>
                    <textarea style={{minHeight: '10em'}} name='post.text' className='form-control' id='text' {...register("post.text")} readOnly={true} />

                    { props.messageType === MessageType.MESSAGE_TYPE_LIFESTORY && <Fragment>
                        <label>Event Date</label>
                        <DatePickerControl  name='post.event_date' control={control} placeHolder='Please Select Date' validate={null}  readOnly={true}/>
                    </Fragment>}

                    {(data.data.image_array[0] !== undefined && data.data.image_array[0] !== null) && <Fragment>
                    <label>Attachments</label>
                        <div className="profile-img-container-wrap profile-img-container-wrap_child">
                            {data.data.image_array.map((imageData) => {
                                return (
                                    <div className="profile-img-wrap">
                                        <img
                                            src={getChildImageUrl(imageData, data.data.user_id)}
                                            alt={'Child Image'}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    </Fragment>}

                    { data.data.link !== '' && data.data.link !== undefined && data.data.link !== null && <div>
                        <label>Youtube Video Link (Example:"https://www.youtube.com/watch?v=75NQK-Sm1YY")</label>
                        <input className='form-control' id='link' {...register("post.link")} readOnly={true}/>
                    </div>}

                    {data.data.document_array[0] !== undefined &&
                        <div style={{marginRight: '10px', marginBottom: '10px', marginTop: '10px'}}>
                            <a href={getDocumentUrl()} target="_blank" style={{marginRight: '10px', marginBottom: '20px'}}>
                                <img alt="document" width="70" src={getDocumentIcon()}></img>
                            </a>
                        </div>
                    }

                    {hasLetterboxComment && <div>
                        <label>Letterbox Comment</label>
                        <textarea style={{minHeight: '10em'}} name='post.letterbox_comment' className='form-control' id='text' {...register("post.letterbox_comment")} readOnly={true} />
                    </div>}

                    <div>
                    <label>Editor Comment</label>
                        <textarea readOnly={readOnlyMode} style={{minHeight: '5em'}} name='post.comment' className='form-control' id='text' {...register("post.comment")} />
                    </div>

                    {!data.isLoading && messageReplyThread && data.data.reply_to_post_id !== null &&
                        messageReplyThread.map((post) =>
                            <div key={post.post_id} className="reply-thread-modal">
                                <p>From: {post.posted_by_name}</p>
                                <p>Sent: {post.posted_date}</p>
                                <p>To: {post.known_as}</p>
                                <p>Subject: {post.title}</p>
                                <div className="reply-thread-modal-body">
                                    <p className="txt">{post.text}</p>
                                </div>
                            </div>
                        )}

                    <div className="d-flex flex-row justify-content-end" style={{marginTop: '15px'}}>
                        <button type='button' onClick={onClickCancel}
                                className="btn btn-icon btn-secondary btn-icon-right btn-small">Close<i className="et-arrow-bold-left"></i></button>
                        {!isReadOnly &&
                            <div>
                                {!outGoingApproval && !isHeld && !isArchived && !isApproved && <button type='button' onClick={() => onClickAction(PostStatus.RETURNED)} style={{marginRight: '10px', marginLeft: '10px'}}
                                        className="btn btn-icon btn-red btn-danger btn-icon-right btn-small">{getReturnButtonText()}<i className="et-check"></i></button>}
                                {!outGoingApproval && !isHeld && <button type='button' onClick={() => onClickAction(PostStatus.PENDING)} style={{marginRight: '10px', marginLeft: '10px'}}
                                        className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">Hold for Later<i className="et-check"></i></button>}
                                {!outGoingApproval && !isArchived && +props.messageType === MessageType.MESSAGE_TYPE_LIFESTORY && <button type='button' onClick={() => onClickAction(PostStatus.HELD)} style={{marginRight: '10px', marginLeft: '10px'}}
                                        className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">Archive<i className="et-check"></i></button>}
                                {!isApproved && <button type='button' onClick={() => onClickAction(PostStatus.APPROVED)} style={{marginRight: '10px', marginLeft: '10px'}}
                                        className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">{getSubmitButtonText()}<i className="et-check"></i></button>}
                            </div>
                        }
                    </div>
                </form>

            </Fragment>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <Title mode={props.mode} messageType={props.messageType}/>

            <div style={{width: props.width}}>
                { data.isLoading && <SpinnerDiv /> }
                { !data.isLoading && renderHookForm ()}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalApprovePost;

ModalApprovePost.defaultProps =
    {
        width: '600px'
    }

ModalApprovePost.propTypes = {
    post_id: PropTypes.string,
    width: PropTypes.string,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
